import type { ApiTaskStatus } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { TaskProgressState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

const API_STATUS_TO_PROGRESS_STATE: Record<ApiTaskStatus, TaskProgressState> = {
	DRAFT: 'Draft',
	QUEUED: 'Queued',
	RUNNING: 'Running',
	AWAITING_DISAMBIGUATION: 'AwaitingDisambiguation',
	AWAITING_PLAN_CONFIRMATION: 'AwaitingPlanConfirmation',
	AWAITING_ACTION_CONFIRMATION: 'AwaitingActionConfirmation',
	COMPLETED: 'Completed',
	FAILED: 'Failed',
	CANCELLED: 'Cancelled',
};

/**
 * Converts an API task status (SCREAMING_SNAKE_CASE) to the local domain
 * TaskProgressState (PascalCase).
 */
export const mapApiTaskStatusToProgressState = (status: ApiTaskStatus): TaskProgressState =>
	API_STATUS_TO_PROGRESS_STATE[status];
